
import { PropType, defineComponent } from 'vue';
import FbxInput from './fbx-input.vue';
import FbxRadio from './fbx-radio.vue';
import FeedbackFormLayout from './FeedbackFormLayout.vue';
import { isNullOrUndefined, trimInput } from '@/shared/helpers';
import globalConstants from '@/shared/globalConstants';
import { FeedbackTypes } from '@/types/FeedbackTypes';
import { PartyType } from '@/types/PartyTypes';
import { FeedbackDetails } from './DriverFeedback.vue';

export default defineComponent({
    components: {
        FbxInput,
        FbxRadio,
        FeedbackFormLayout,
    },
    emits: ['onNavigateBack', 'onSubmit'],
    props: {
        feedbackOption: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
    },
    data(): {
        customerName: string | null;
        radioSelection: PartyType | undefined;
        trailerNumber: string | null;
        mcDotNumber: string | null;
        truckNumber: string | null;
    } {
        return {
            customerName: null,
            radioSelection: undefined,
            trailerNumber: null,
            mcDotNumber: null,
            truckNumber: null,
        };
    },
    computed: {
        firstParty() {
            return PartyType.firstParty;
        },
        thirdParty() {
            return PartyType.thirdParty;
        },
        showMcDotInput() {
            return this.radioSelection === this.thirdParty;
        },
        showTruckNumberInput() {
            return this.radioSelection === this.firstParty;
        },
        driverCompany(): string {
            return this.$route.params.company as string;
        },
        isAttachedToAnotherTruck() {
            return this.feedbackOption === FeedbackTypes.anotherTruckIsAttached;
        },
        isFormValid() {
            if (this.isAttachedToAnotherTruck) {
                return (
                    !isNullOrUndefined(this.trailerNumber) &&
                    !isNullOrUndefined(this.radioSelection)
                );
            }

            return (
                !isNullOrUndefined(this.trailerNumber) &&
                !isNullOrUndefined(this.customerName)
            );
        },
        isSubmitDisabled() {
            return !this.isFormValid;
        },
        title() {
            if (this.feedbackOption === null) return '';
            return globalConstants.driverFeedback.options[this.feedbackOption];
        },
    },
    methods: {
        onNavigateBack() {
            this.$emit('onNavigateBack');
        },
        onSubmit() {
            const feedbackDetails: FeedbackDetails = {
                trailerNumber: this.trailerNumber,
                customerName: this.customerName,
                partyType: this.radioSelection,
                mcDotNumber: this.mcDotNumber,
                truckNumber: this.truckNumber,
            };
            this.$emit('onSubmit', feedbackDetails);
        },
    },
    watch: {
        customerName() {
            if (!(this.customerName === '')) return;
            this.customerName = null;
        },
        trailerNumber() {
            if (this.trailerNumber === '') {
                this.trailerNumber = null;
                return;
            }
        },
        truckNumber() {
            this.truckNumber = trimInput(this.truckNumber);
        },
        mcDotNumber() {
            this.mcDotNumber = trimInput(this.mcDotNumber);
        },
    },
});
